import { useQuery } from '@tanstack/react-query';
import {
  fetchExecutionLogs,
  fetchMachineExecutionLogs,
  fetchJobExecutionLogs,
  fetchExecutionLogsSummary
} from '../api/executionLogsApi.js';

export function useExecutionLogs(filters = {}) {
  return useQuery({
    queryKey: ['execution-logs', filters],
    queryFn: () => fetchExecutionLogs(filters),
    keepPreviousData: true
  });
}

export function useMachineExecutionLogs(machineId, filters = {}) {
  return useQuery({
    queryKey: ['execution-logs', 'machine', machineId, filters],
    queryFn: () => fetchMachineExecutionLogs(machineId, filters),
    enabled: !!machineId,
    keepPreviousData: true
  });
}

export function useJobExecutionLogs(jobId) {
  return useQuery({
    queryKey: ['execution-logs', 'job', jobId],
    queryFn: () => fetchJobExecutionLogs(jobId),
    enabled: !!jobId
  });
}

export function useExecutionLogsSummary(filters = {}) {
  return useQuery({
    queryKey: ['execution-logs', 'summary', filters],
    queryFn: () => fetchExecutionLogsSummary(filters)
  });
}
